import { Box, Button, Container, Paper, Tooltip, Typography, keyframes, styled, useMediaQuery, useTheme } from '@mui/material'
import Switch from '@mui/material/Switch';
import React, { useRef, useState } from 'react'
import EastIcon from '@mui/icons-material/East';
import VerifiedIcon from '@mui/icons-material/Verified';
import CloseIcon from '@mui/icons-material/Close';
import Slider from 'react-slick';
import { IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../styles/Pricing.css'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import timer from '../assets/images/timer.png'
import EmergencyIcon from '@mui/icons-material/Emergency';
import FormSubmission from './FormSubmission';

const glowEffect = keyframes`
        0% { filter: blur(4px) opacity(0.7); }
        50% { filter: blur(10px) opacity(1); }
        100% { filter: blur(6px) opacity(0.8); }
    `;

const PricingCardContainer = styled(({ isPreview, isMobile, index, ...rest }) => <Paper {...rest} />)(({ theme, index, isPreview, isMobile }) => ({
    textAlign: 'left',
    color: '#FFFFFF',
    borderRadius: '15px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    // width:"50%",
    // bgcolor:"blue",
    minHeight: 'auto',
    position: 'relative',
    backgroundColor: index === 0 || index === 1 ? '#110f0f' : 'transparent',
    backgroundImage: index === 2
        ? 'linear-gradient(180deg, #110F0F 0%, #212529 100%)'
        : 'none',

    ...(isPreview && isMobile && {
        "&::before": {
            content: '""',
            position: "absolute",
            inset: "-3px",
            borderRadius: '15px',
            padding: "3px",
            background: "linear-gradient(68deg, #2E3393 -1.82%, #1CFAFC 106.59%)",
            filter: "blur(8px)",
            zIndex: "-1",
            animation: `${glowEffect} 1.5s infinite alternate`,
        },
    }),

    border: index === 0 || index === 1 ? "1px solid #A1AEBF" : 'none',

    ...(index == 1 && {
        boxShadow: `
            inset 0 0 18px rgba(244, 14, 83, 0.6),
            inset 0 0 5px rgba(28, 250, 252, 0.4),
            inset 0 0 2px rgba(255, 255, 255, 0.2)
        `,
        "&::after": {
            content: '""',
            position: "absolute",
            inset: "0",
            borderRadius: '15px',
            background: "linear-gradient(68deg, rgba(255, 15, 87, 0.1), rgba(28, 250, 252, 0.1))",
            filter: "blur(8px)",
            opacity: 0.6,
            animation: `${glowEffect} 3s infinite alternate`,
            pointerEvents: "none"
        }
    }),

    [theme.breakpoints.down(575)]: {
        minHeight: index === 0 ? '780px' : index === 1 ? '880px' : 'auto',
    },
    [theme.breakpoints.down(426)]: {
        minHeight: index === 0 ? '760px' : index === 1 ? '860px' : 'auto',
    },
    [theme.breakpoints.down(375)]: {
        height: index === 0 ? '840px' : index === 1 ? '880px' : 'auto',
    },
    [theme.breakpoints.down(365)]: {
        height: index === 0 ? '720px' : index === 1 ? '910px' : 'auto',
    },
    [theme.breakpoints.down(356)]: {
        height: index === 0 ? '850px' : index === 1 ? '930px' : 'auto',
    },
    [theme.breakpoints.down(321)]: {
        height: index === 0 ? '860px' : index === 1 ? '970px' : 'auto',
    },
    [theme.breakpoints.between(577, 600)]: {
        height: index === 0 ? '880px' : index === 1 ? '970px' : 'auto',
    },
    [theme.breakpoints.up('sm')]: {
        height: index === 0 ? 'auto' : index === 1 ? 'auto' : 'auto',
    },
    [theme.breakpoints.up('md')]: {
        height: index === 0 ? 'auto' : index === 1 ? 'auto' : 'auto',
    },
    [theme.breakpoints.up('lg')]: {
        height: index === 0 ? 'auto' : index === 1 ? 'auto' : 'auto'
    },
}));

const CustomTooltip = ({ title, children }) => (
    <Tooltip
        title={
            <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                {title}
            </span>
        }
        arrow
        placement="top"
        enterTouchDelay={0}
        leaveTouchDelay={3000}
        disableInteractive
        PopperProps={{
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: "window",
                    },
                },
            ],
        }}
        componentsProps={{
            tooltip: {
                sx: {
                    maxWidth: "200px",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    fontSize: "12px",
                    background: "black"
                },
            },
            arrow: {
                sx: {
                    color: "black",
                },
            },
        }}
    >
        {children}
    </Tooltip>
);


const Pricing = () => {

    const [selectedCard, setSelectedCard] = useState(null);
    const currentMonth = new Date().toLocaleString('en-US', { month: 'long' });
    const [hoveredOne, setHoveredOne] = useState(false);
    const [hoveredTwo, setHoveredTwo] = useState(false);
    const [showFreeInternship, setShowFreeInternship] = useState(false);

    const pricingData = [
        {
            title: 'intern lite',
            originalPrice: '₹1000',
            currency: '₹',
            discountedPrice: '0',
            description: 'No-Cost Entry to Skill Development',
            applyText: `Start for Free`,
            cardStyle: {
                // width: '100px',
                height: '500px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            },
            features: [
                { checked: true, text: 'Self-paced' },

                { checked: true, text: 'Online Mode' },
                {
                    checked: true, text:
                        <CertificateText>
                            4 Sprints &nbsp;
                            <Tooltip
                                title="1 Sprint = 1 Week"
                                arrow
                                placement="top"
                                enterTouchDelay={0}
                                leaveTouchDelay={3000}
                                disableInteractive
                                PopperProps={{
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                }}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: "200px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            fontSize: "12px",
                                            background: "black",
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: "black",
                                        },
                                    },
                                }}
                            >
                                <Box sx={{ position: "relative", top: "3px", display: "inline-flex" }}>
                                    <InfoOutlinedIcon sx={{ fontSize: '14px' }} />
                                </Box>
                            </Tooltip>
                        </CertificateText>
                },

                // { checked: true, text: 'Free Learning Materials' },
                // { checked: true, text: 'Less than 30 hrs/week' },
                // { checked: true, text: 'Agile Learning Process' },
                // { checked: true, text: 'Upto 360 hours in 3 Months' },
                // { checked: true, text: <HighlightedText>Work on real customer projects</HighlightedText> },
                // { checked: true, text: 'Stipend from Companies' },
                {
                    checked: false,
                    text: (
                        <CertificateText>
                            Internship Certificate &nbsp;
                            <Tooltip
                                title="Switch to INTERN or LEARN+INTERN to Receive Certificate"
                                arrow
                                placement="top"
                                enterTouchDelay={0}
                                leaveTouchDelay={3000}
                                disableInteractive
                                PopperProps={{
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                }}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: "200px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            fontSize: "12px",
                                            background: "black",
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: "black",
                                        },
                                    },
                                }}
                            >
                                <Box sx={{ position: "relative", top: "3px", display: "inline-flex" }}>
                                    <InfoOutlinedIcon sx={{ fontSize: '14px' }} />
                                </Box>
                            </Tooltip><br />

                        </CertificateText>
                    ),
                },
                {
                    checked: false, text:
                        <CertificateText>
                            Eligible for <HighlightedText3>STIPEND </HighlightedText3> &nbsp;
                            <Tooltip
                                title="Upgrade to be eligible"
                                arrow
                                placement="top"
                                enterTouchDelay={0}
                                leaveTouchDelay={3000}
                                disableInteractive
                                PopperProps={{
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                }}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: "200px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            fontSize: "12px",
                                            background: "black",
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: "black",
                                        },
                                    },
                                }}
                            >
                                <Box sx={{ position: "relative", top: "3px", display: "inline-flex" }}>
                                    <InfoOutlinedIcon sx={{ fontSize: '14px' }} />
                                </Box>
                            </Tooltip>
                        </CertificateText>
                },
                // { checked: false, text: 'Internship Offer Letter' },
                // { checked: false, text: 'Recommendation Letter' },
                { checked: false, text: 'Immersive & Experiencial Learning' },

            ],
            internships: [
                // { checked: true, text: 'Task practice' },
                {
                    checked: true,
                    text:
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                            <HighlightedText>Job Simulation </HighlightedText>
                            <CustomTooltip title="Real problem statements from real-time projects">
                                <InfoOutlinedIcon fontSize='14px' />
                            </CustomTooltip>
                        </Box>
                },
                { checked: true, text: 'Completion Review' },
                {
                    checked: true, text:
                        <CertificateText>
                            Gen-AI Infusion &nbsp;
                            <Tooltip
                                title="Hands-on with Gen-AI tools to get things done quickly and easily"
                                arrow
                                placement="top"
                                enterTouchDelay={0}
                                leaveTouchDelay={3000}
                                disableInteractive
                                PopperProps={{
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                }}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: "200px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            fontSize: "12px",
                                            background: "black",
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: "black",
                                        },
                                    },
                                }}
                            >
                                <Box sx={{ position: "relative", top: "3px", display: "inline-flex" }}>
                                    <InfoOutlinedIcon sx={{ fontSize: '14px' }} />
                                </Box>
                            </Tooltip>
                        </CertificateText>
                },
                {
                    checked: true,
                    text: "Work on Real Customer Projects "

                },
                { checked: true, text: 'Deploy on Github' },
                { checked: false, text: 'Weekly Huddle with Mentor' },


                // {
                //     checked: true,
                //     text:
                //         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                //             <HighlightedText>4 Sprints </HighlightedText>
                //             <CustomTooltip title={
                //                 <span style={{ whiteSpace: "normal", wordBreak: "break-word", color: "rgba(255, 255, 255, 0.37)" }}>
                //                     Typically <span style={{ color: "white" }}>1 sprint</span> is equal to
                //                     <span style={{ color: "white" }}> 1 week</span>.
                //                 </span>
                //             }>
                //                 <InfoOutlinedIcon fontSize='14px' />
                //             </CustomTooltip>
                //         </Box>
                // },
                // { checked: true, text: 'Agile Learning Process' },
                // {
                //     checked: true, text: <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>Unlock
                //         <HighlightedText3>STIPEND </HighlightedText3>
                //         <CustomTooltip title="Step towards STIPEND eligibility.">
                //             <InfoOutlinedIcon fontSize='14px' />
                //         </CustomTooltip>
                //     </Box>
                // },
            ],
        },
        {
            title: 'intern',
            originalPrice: '₹3000',
            currency: '₹',
            discountedPrice: '999',
            description: 'Expert-reviewed work with a certificate to showcase your skills',
            // applyText: (
            //     <>100% Refund <Typography component="span" color="white" sx={{ marginLeft: "3px" }}>*</Typography></>
            // ),
            applyText: `Secure Your ${currentMonth} Spot`,
            features: [
                { checked: true, text: 'Self-paced' },

                { checked: true, text: 'Online / Offline Mode' },
                {
                    checked: true, text:
                        <CertificateText>
                            4 Sprints &nbsp;
                            <Tooltip
                                title="1 Sprint = 1 Week"
                                arrow
                                placement="top"
                                enterTouchDelay={0}
                                leaveTouchDelay={3000}
                                disableInteractive
                                PopperProps={{
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                }}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: "200px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            fontSize: "12px",
                                            background: "black",
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: "black",
                                        },
                                    },
                                }}
                            >
                                <Box sx={{ position: "relative", top: "3px", display: "inline-flex" }}>
                                    <InfoOutlinedIcon sx={{ fontSize: '14px' }} />
                                </Box>
                            </Tooltip>
                        </CertificateText>
                },
                { checked: true, text: 'Internship Offer Letter' },
                // { checked: true, text: 'Free Learning Materials' },
                // { checked: true, text: 'Less than 30 hrs/week' },
                // { checked: true, text: 'Agile Learning Process' },
                // { checked: true, text: 'Upto 360 hours in 3 months' },
                // { checked: true, text: <HighlightedText>Work on real customer projects</HighlightedText> },
                // { checked: true, text: 'Stipend from companies' },
                { checked: true, text: <CertificateText>Internship Certificate <br /><SubText>(Directly From Verified Companies)</SubText></CertificateText> },
                {
                    checked: false, text:
                        <CertificateText>
                            Eligible for <HighlightedText3>STIPEND </HighlightedText3> &nbsp;
                            <Tooltip
                                title="Upgrade to be eligible"
                                arrow
                                placement="top"
                                enterTouchDelay={0}
                                leaveTouchDelay={3000}
                                disableInteractive
                                PopperProps={{
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                }}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: "200px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            fontSize: "12px",
                                            background: "black",
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: "black",
                                        },
                                    },
                                }}
                            >
                                <Box sx={{ position: "relative", top: "3px", display: "inline-flex" }}>
                                    <InfoOutlinedIcon sx={{ fontSize: '14px' }} />
                                </Box>
                            </Tooltip>
                        </CertificateText>
                },
                { checked: false, text: 'Recommendation Letter' },
                { checked: false, text: 'Immersive & Experiencial Learning' },


            ],
            // title2: <Title2Text>Everything from<HighlightedText2> Self</HighlightedText2> and . . . .</Title2Text>,
            internships: [
                {
                    checked: true,
                    text:
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                            <HighlightedText>Job Simulation </HighlightedText>
                            <CustomTooltip title="Real problem statements from real-time projects">
                                <InfoOutlinedIcon fontSize='14px' />
                            </CustomTooltip>
                        </Box>
                },
                { checked: true, text: 'Completion Review' },
                {
                    checked: true, text:
                        <CertificateText>
                            Gen-AI Infusion &nbsp;
                            <Tooltip
                                title="Hands-on with Gen-AI tools to get things done quickly and easily"
                                arrow
                                placement="top"
                                enterTouchDelay={0}
                                leaveTouchDelay={3000}
                                disableInteractive
                                PopperProps={{
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                }}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: "200px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            fontSize: "12px",
                                            background: "black",
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: "black",
                                        },
                                    },
                                }}
                            >
                                <Box sx={{ position: "relative", top: "3px", display: "inline-flex" }}>
                                    <InfoOutlinedIcon sx={{ fontSize: '14px' }} />
                                </Box>
                            </Tooltip>
                        </CertificateText>
                },
                {
                    checked: true,
                    text: "Work on Real Customer Projects"
                },

                { checked: true, text: 'Deploy On Github' },
                { checked: false, text: 'Weekly Huddle with Mentor' },
            ],
            // placements: [
            //     { checked: true, text: 'Resume preparation' },
            //     // { checked: true, text: 'Placement assistance' },
            //     { checked: true, text: 'Business English Training' },
            //     { checked: true, text: 'Softskill Training' },
            // ]
        },
        {
            title: 'learn ',
            title1: ' intern',
            originalPrice: '₹5000',
            currency: '₹',
            discountedPrice: '2,999',
            description: 'Your path to full job-readiness with real-world experience.',
            // applyText: (
            //     <>100% Refund <Typography component="span" color="white" sx={{ marginLeft: "3px" }}>*</Typography></>
            // ),
            applyText: `Secure Your ${currentMonth} Spot`,
            cardStyle: {
                // width: '500px',
                minHeight: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            },
            features: [
                { checked: true, text: 'Immersive & Experiencial Learning' },
                { checked: true, text: 'Online / Offline Mode' },
                {
                    checked: true, text:
                        <CertificateText>
                            4 Sprints &nbsp;
                            <Tooltip
                                title="1 Sprint = 1 Week"
                                arrow
                                placement="top"
                                enterTouchDelay={0}
                                leaveTouchDelay={3000}
                                disableInteractive
                                PopperProps={{
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                }}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: "200px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            fontSize: "12px",
                                            background: "black",
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: "black",
                                        },
                                    },
                                }}
                            >
                                <Box sx={{ position: "relative", top: "3px", display: "inline-flex" }}>
                                    <InfoOutlinedIcon sx={{ fontSize: '14px' }} />
                                </Box>
                            </Tooltip>
                        </CertificateText>
                },
                { checked: true, text: 'Internship Offer Letter' },
                { checked: true, text: <CertificateText>Internship Certificate <br /><SubText>(Directly From Verified Companies)</SubText></CertificateText> },

                { checked: true, text: 'Recommendation Letter' },
                {
                    checked: true, text: <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>Eligible for
                        <HighlightedText3>STIPEND </HighlightedText3>
                    </Box>
                },

                // { checked: true, text: 'Agile Learning Process' },
                // {
                //     checked: true,
                //     text:
                //         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                //             <HighlightedText>Work on Real Customer Projects</HighlightedText>
                //         </Box>
                // },
                // { checked: true, text: 'Stipend from Companies' },
                // {
                //     checked: true,
                //     text: (
                //         <CertificateText>
                //             Internship Certificate <br />
                //             <SubText>(Directly From Verified Companies)</SubText>
                //         </CertificateText>
                //     ),
                // }
            ],
            internships: [
                {
                    checked: true,
                    text:
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                            <HighlightedText>Job Simulation </HighlightedText>
                            <CustomTooltip title="Real problem statements from real-time projects">
                                <InfoOutlinedIcon fontSize='14px' />
                            </CustomTooltip>
                        </Box>
                },
                { checked: true, text: 'Completion Review' },
                {
                    checked: true, text:
                        <CertificateText>
                            Gen-AI Infusion &nbsp;
                            <Tooltip
                                title="Hands-on with Gen-AI tools to get things done quickly and easily"
                                arrow
                                placement="top"
                                enterTouchDelay={0}
                                leaveTouchDelay={3000}
                                disableInteractive
                                PopperProps={{
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                }}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: "200px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            fontSize: "12px",
                                            background: "black",
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: "black",
                                        },
                                    },
                                }}
                            >
                                <Box sx={{ position: "relative", top: "3px", display: "inline-flex" }}>
                                    <InfoOutlinedIcon sx={{ fontSize: '14px' }} />
                                </Box>
                            </Tooltip>
                        </CertificateText>
                },
                {
                    checked: true, text: "Work on Real Customer Projects"
                },
                { checked: true, text: 'Weekly Huddle with Mentor' },
                // {
                //     checked: true, text: <CertificatePortText>Portfolio <span style={{ marginRight: "4px" }}></span>
                //         <SubPortText>(
                //             <LinkedInIcon sx={{ fontSize: "16px", color: "#006eab", marginRight: .5 }} />
                //             <span>LinkedIn</span>
                //             )</SubPortText>
                //     </CertificatePortText>
                // },
                { checked: true, text: 'Live Support & Doubt Clearance' },
                { checked: true, text: <CertificateText>Code + Task Review <SubText>(Github PR)</SubText></CertificateText> },
                // {
                //     checked: true, text: < Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px" }} >
                //         <HighlightedText>16 Immersive Sprints</HighlightedText>
                //         <CustomTooltip title={
                //             <span style={{ whiteSpace: "normal", wordBreak: "break-word", color: "rgba(255, 255, 255, 0.37)" }}>
                //                 Typically <span style={{ color: "white" }}>1 sprint</span> is equal to
                //                 <span style={{ color: "white" }}> 1 week</span>.
                //             </span>
                //         }>
                //             <InfoOutlinedIcon fontSize='14px' />
                //         </CustomTooltip>
                //     </Box >
                // },
                { checked: true, text: 'Project Guidance' },
                {
                    checked: true,
                    text:
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                            <HighlightedText>Placement Assistance </HighlightedText>
                        </Box>
                },
                { checked: true, text: 'Agile Learning Process' },

            ],
            // placements: [
            //     { checked: true, text: 'Resume Preparation' },
            //     {
            //         checked: true, text: <CertificatePortText>Portfolio <span style={{ marginRight: "4px" }}></span>
            //             <SubPortText>(
            //                 <LinkedInIcon sx={{ fontSize: "16px", color: "#006eab", marginRight: .5 }} />
            //                 <span>LinkedIn</span>
            //                 )</SubPortText>
            //         </CertificatePortText>
            //     },
            //     // { checked: true, text: 'Team Project' },
            //     // { checked: true, text: 'Project Guidance' },
            //     { checked: true, text: 'Mock Interview' },
            // ]
        },
    ];

    const sliderRef = useRef(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [activeIndex, setActiveIndex] = useState(1);
    // const isPreviewMode = true; // Set this dynamically based on preview mode

    const [open, setOpen] = React.useState(false);

    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    const handleClickOpen = (index) => {
        console.log(index);

        if (index === 0 || index === 1 || index === 2) {
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const settings = {
        dots: isMobile && true,
        appendDots: dots => (
            <Box component="ul" sx={{ bottom: "50px", position: "absolute" }}>
                {dots}
            </Box>
        ),
        infinite: false,
        speed: 500,
        slidesToShow: isMobile ? 1 : 3,
        slidesToScroll: 1,
        centerMode: isMobile && true,
        centerPadding: isMobile && "8%", // adjust to your design
        initialSlide: 1, // this centers the second card
        swipeToSlide: isMobile && true,         // ✅ Allow free swipe by touch

        afterChange: (current) => {
            setActiveIndex(current);
        },
        nextArrow: (
            <CustomNextArrow
                onClick={() => sliderRef.current && sliderRef.current.slickNext()}
            />
        ),
        prevArrow: (
            <CustomPrevArrow
                onClick={() => sliderRef.current && sliderRef.current.slickPrev()}
            />
        ),

    };



    const handleApplyClick = (card) => {
        setSelectedCard(card);
        let message = "";

        if (card.title === "Self") {
            message = "Hello Can I get more info ";
        } else if (card.title === "Pro") {
            message = "I would like to know more about the refund process.";
        } else if (card.title === "Prime") {
            message = "I would like to know more about the refund process.";
        }

        const encodedMessage = encodeURIComponent(message);

        const phoneNumber = "919385647154";

        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

        window.open(whatsappURL, "_blank");
    };

    const label = { inputProps: { 'aria-label': 'Switch demo' } };

    return (
        <section id="pricing">
            <Box sx={{
                backgroundColor: "#110f0f", minHeight: "100vh",
                color: "#fff", py: { xs: 4, sm: 8 }, px: { xs: 0, sm: 2, md: 2 }
            }}>
                <Container maxWidth="lg" align="center" >
                    <Box>
                        <Container maxWidth="lg"  >
                            {/* <Typography
                                variant="h4"
                                mb={3}
                                fontWeight="500"
                                gutterBottom
                                // align="left"
                                sx={{
                                    color: '#FFFFFF',
                                    fontSize: { xs: "28px", sm: "25px", md: "30px", lg: "40px" },
                                }}>
                                Tailored Programmes for Your Career Growth
                            </Typography> */}
                            <Typography
                                variant="h4"
                                mb={3}
                                fontWeight="500"
                                gutterBottom
                                // align="left"
                                sx={{
                                    color: '#FFFFFF',
                                    fontSize: { xs: "28px", sm: "25px", md: "30px", lg: "40px" },
                                }}>
                                Tailored Programmes for Your Career Growth
                            </Typography>
                            <Typography variant='body1' sx={{
                                color: 'rgba(255, 255, 255, 0.40)', fontSize: '13px', [theme.breakpoints.down('375')]: {
                                    fontSize: "0.7rem"
                                }, maxWidth: { xs: "100%", sm: '70%' }
                            }}>
                                We have solved your problem of finding an internship and excelling in your career into these three buckets below
                            </Typography>
                        </Container>
                    </Box>
                </Container >
                <Box sx={{ width: '100%', height: "auto", marginTop: "70px" }}>
                    <Slider ref={sliderRef} {...settings}  >
                        {pricingData
                            .map((card, index) => (
                                <Box key={index} sx={{ display: "flex", justifyContent: "center", height: "auto", marginTop: isMobile ? index === 1 ? 5 : 9 : index === 1 ? 5 : 15, marginBottom: 5, justifyContent: "space-around" }}>
                                    <PricingCardContainer
                                        elevation={3}
                                        index={index}
                                        isPreview={index !== activeIndex}
                                        isMobile={isMobile}
                                        sx={{
                                            width: isMobile ? "97%" : "90%",
                                            ...(index === 2 && {
                                                background: 'linear-gradient(74deg, #000428 0%, #004E92 113.02%)',
                                                boxShadow: "10px 0 30px 10px rgba(0, 78, 146, 0.6)", // Matches #004E92
                                                border: "1px solid rgba(0, 78, 146, 0.4)",
                                                transition: "all 0.3s ease-in-out",
                                            })
                                        }}
                                    >
                                        {/* <Box></Box> */}
                                        <Box textAlign={"center"} >
                                            <Typography variant="h4" sx={{
                                                textTransform: "uppercase",
                                                marginBottom: "15px",
                                                marginTop: index === 2 ? "58px" : "35px",
                                            }}>
                                                {/* <Box component="span" sx={{ fontSize: "25px", fontWeight: 500, color: "rgba(255, 255, 255, 0.32)" }}>INTERN </Box> */}
                                                <Box component="span" sx={{
                                                    fontSize: "35px",
                                                    fontWeight: 700,
                                                    background: index === 0
                                                        ? "linear-gradient(to right, #2E3393, #1CFAFC)"
                                                        : index === 1
                                                            ? "linear-gradient(to right, #FFFFFF -1.82%, #FF155B)"
                                                            : "linear-gradient(to right, #FFA800, #FFFFFF)",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent",
                                                    backgroundClip: "text",
                                                }}>
                                                    {index === 2 ? (
                                                        <>
                                                            <Box component="span" sx={{ fontSize: "40px" }}> {card.title}</Box>
                                                            <Box component="span" sx={{ fontSize: "20px", }}>+</Box>
                                                            <Box component="span" sx={{ fontSize: "40px" }}>{card.title1} </Box>
                                                        </>
                                                    ) : (
                                                        card.title
                                                    )}</Box>
                                            </Typography>
                                        </Box>
                                        {/* {index === 1 || index === 2 ? <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.32)', ml: 3, position: "absolute", top: '6%', left: '8%', background: 'linear-gradient(69deg, #FF0A54 4.18%, #FAE0E4 145.93%)', color: "white", transform: ' translate(-50%,-50%) rotate(-39deg)', padding: "4px 30px", fontSize: "15px", height: "fit-content", width: "100%", textAlign: "center", overflow: "hidden",clipPath: 'inset(0 0 0 0)' }}>
                                            15 Days Free Trial
                                        </Typography> : ""} */}
                                        {index === 1 || index === 2 ? <Box sx={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            width: '100%',
                                            height: '100%',
                                            overflow: 'hidden',
                                            pointerEvents: 'none',
                                        }}>
                                            <Box sx={{
                                                position: 'absolute',
                                                top: { xs: 35, sm: 25, md: 50 },
                                                right: { xs: -60, sm: -60, md: -100 },
                                                // left: { xs: 'auto', md: 220 },
                                                width: { xs: 200, sm: 250, md: 300 },
                                                transform: 'rotate(40deg)',
                                                background: 'linear-gradient(69deg, #2dc653 4.18%, #FAE0E4 145.93%)',
                                                padding: "4px 0",
                                                paddingRight: { xs: '20px', sm: '30px', lg: '40px' },
                                                paddingLeft: { sm: '50px', md: '0px' },

                                                textAlign: "center",
                                                color: "white",
                                                fontSize: "15px",
                                                fontWeight: 600,
                                                clipPath: 'inset(0 0 0 0)',
                                            }}>
                                                Get Certified
                                            </Box>
                                        </Box>
                                            : ""}
                                        {(index === 1 || index === 2) && (
                                            <Box
                                                component="img"
                                                src={require("../assets/images/verified account.png")}
                                                alt="Verified"
                                                sx={{
                                                    position: 'absolute',
                                                    top: { xs: 10, sm: 10, md: 12 },
                                                    right: { xs: 10, sm: 10, md: 12 },
                                                    width: { xs: 25, sm: 28, md: 30 },
                                                    height: { xs: 25, sm: 28, md: 30 },
                                                    zIndex: 10,
                                                    opacity: 0.6,
                                                }}
                                            />
                                        )}

                                        {/* <Typography variant="h6" sx={{ color: 'rgba(255, 255, 255, 0.32)', mr: 2, lineHeight: "25px", fontSize: "15px", textAlign: "center" }}>
                                            Starts From
                                        </Typography> */}
                                        <Box sx={{ display: "flex", alignItems: "start", flexDirection: "column", marginTop: index === 0 ? "5px" : "30px" }}>
                                            <Box>
                                                <Typography variant="h6" sx={{ color: "rgba(255,255,255,0.32)", textDecoration: "line-through", position: "relative", top: "0px" }}>
                                                    {card.originalPrice}
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                    <Typography variant="h6" sx={{ color: "rgba(255,255,255,0.32)" }}>
                                                        {card.currency}
                                                    </Typography>
                                                    <Typography variant="h4" fontWeight="bold" sx={{ color: "#FFFFFF", fontSize: { xs: "30px", sm: "auto" } }}>
                                                        {card.discountedPrice}
                                                    </Typography>
                                                    {(index === 1 || index === 0) && (
                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                background: "linear-gradient(69deg, #FF0A54 4.18%, #FAE0E4 145.93%)",
                                                                fontSize: "10px",
                                                                marginLeft: "10px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                px: 1,
                                                                py: 0.2,
                                                            }}
                                                        >
                                                            LIMITED TIME OFFER
                                                            <Box component="img" src={timer} alt="" sx={{ height: "20px", marginLeft: "5px" }} />
                                                        </Button>
                                                    )}
                                                </Box>
                                            </Box>

                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: "#EEEEEE",
                                                    mb: 3,
                                                    fontSize: "14px",
                                                    fontWeight: 200,
                                                }}
                                            >
                                                {card.description}
                                            </Typography>
                                        </Box>

                                        <Button
                                            variant="contained"
                                            // onClick={() => handleApplyClick(card)}
                                            onClick={() => handleClickOpen(index)}
                                            // onMouseEnter={() => {
                                            //     if (index === 1) setHoveredOne(true);
                                            //     if (index === 2) setHoveredTwo(true);
                                            // }}
                                            // onMouseLeave={() => {
                                            //     if (index === 1) setHoveredOne(false);
                                            //     if (index === 2) setHoveredTwo(false);
                                            // }}
                                            sx={{
                                                textTransform: "uppercase",
                                                position: "relative",
                                                background:
                                                    index === 0
                                                        ? "linear-gradient(68deg, #2E3393 -1.82%, #1CFAFC 106.59%)"
                                                        : index === 2
                                                            ? "linear-gradient(225.92deg, #33D2FF 5.73%, #3D68DE 54.65%, #9845E8 96.75%)"
                                                            : index === 1 ? "linear-gradient(to right, #FF0F57, #1CFAFC)" : "none",
                                                borderRadius: "6px",
                                                fontSize: { xs: "9px", sm: "9px", lg: "13px" },
                                                fontWeight: "bold",
                                                width: {
                                                    xs: "100%", sm: (index === 1 && hoveredOne) || (index === 2 && hoveredTwo) ? "100%" : "80%",
                                                }, // ✅ Fixed width to prevent layout shift
                                                minWidth: "160px", // ✅ Ensures width remains stable
                                                padding: { xs: "7px", sm: "auto" },
                                                transition: "all 0.3s ease-in-out", // ✅ Smooth transition for text change
                                                whiteSpace: "nowrap", // ✅ Prevents text wrapping
                                                display: "flex", // ✅ Keeps text & icon aligned
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            {/* {(index === 2 && hoveredTwo) ? "100% Refund for first 500 Interns" : card.applyText}
                                        <EastIcon sx={{ marginLeft: "8px", transition: "transform 0.3s ease-in-out" }} /> */}
                                            {/* {(index === 2) ? <Typography sx={{ position: "absolute", bottom: -20, right: 0, fontSize: "9px" }}>Upon Successful Completion</Typography> : ""} */}
                                            {card.applyText}<EastIcon sx={{ marginLeft: "8px", transition: "transform 0.3s ease-in-out" }} />
                                        </Button>

                                        <FormSubmission open={open} handleClose={handleClose} />


                                        <Box padding='15px 0px' sx={{ color: "white", fontWeight: '400', mt: 2 }}>
                                            {card.features && card.features.length > 0 && (
                                                <Box padding={{ xs: "5px 18px", md: '5px 24px' }}
                                                >
                                                    {
                                                        card.features.map((feature, index) => (
                                                            <FeatureItem key={index} feature={feature} />
                                                        ))
                                                    }
                                                </Box>
                                            )}
                                            {card.title2 && <Typography variant='h5' sx={{ fontSize: "16px", textAlign: "center" }}>
                                                {card.title2}
                                            </Typography>}

                                            {card.internships && card.internships.length > 0 && (
                                                <SectionBox index={index} title="Internship" items={card.internships} />
                                            )}

                                            {card.placements && card.placements.length > 0 && (
                                                <SectionBox index={index} title="Placement" items={card.placements} />
                                            )}
                                        </Box>


                                    </PricingCardContainer>

                                </Box>
                            ))
                        }
                    </Slider >
                </Box>
            </Box >
        </section >
    );
};

const FeatureItem = ({ feature }) => (
    <Box sx={{ display: 'flex', alignItems: 'start', gap: 1, marginBottom: 1 }}>
        <Typography variant='body2' component="span" sx={{ fontSize: "13px" }}>
            {feature.checked ? <VerifiedIcon sx={{ fontSize: { xs: "14px", lg: "16px" }, color: "#3ED37A" }} /> : <CloseIcon sx={{ color: 'red', fontSize: "18px" }} />}
        </Typography>
        <Typography variant='body2' component="span" sx={{ fontSize: { xs: "11px", lg: "14px" }, fontWeight: 200 }}>
            {feature.text}
        </Typography>
    </Box>
);

const SectionBox = ({ index, title, items }) => (
    <Box sx={{
        background: index % 2 === 1 ? 'linear-gradient(180deg, rgba(19, 22, 27, 0.20) 0%, rgba(22, 43, 96, 0.20) 100%)' : 'linear-gradient(180deg, rgba(0, 7, 45, 0.20) 0%, rgba(32, 36, 39, 0.20) 100%)',
        backdropFilter: 'blur(5.099999904632568px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        // borderRight: '1px solid rgba(255, 255, 255, 0.1)',
        padding: { xs: "5px 18px", md: '5px 24px' },
        mt: 2,
        borderRadius: '12px',
    }}>
        <Typography variant='h6' margin='15px 0px' sx={{ color: "#3ED37A" }}>{title}</Typography>
        {items.map((item, index) => (
            <FeatureItem key={index} feature={item} />
        ))}
    </Box>
);

const HighlightedText = ({ children }) => (
    <span style={{ color: "#1FD7E9", fontWeight: 600 }}>{children}</span>
);
const HighlightedText2 = ({ children }) => (
    <span style={{ color: "#FFA800", fontWeight: 600, textTransform: "uppercase" }}>{children}</span>
);
const HighlightedText3 = ({ children }) => (
    <span style={{ color: "#ffffff", fontWeight: 600, textTransform: "uppercase" }}>{children}</span>
);
const HighlightedText4 = ({ children }) => (
    <span style={{ background: "linear-gradient(to right, #2E3393, #1CFAFC)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", fontWeight: 700, textTransform: "uppercase", }}>{children}</span>
);
const HighlightedText5 = ({ children }) => (
    <span style={{ background: "linear-gradient(to right, #FFFFFF, #FF155B)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", fontWeight: 700, textTransform: "uppercase", }}>{children}</span>
);

const CertificateText = ({ children }) => (
    <>{children}</>
);

const SubText = ({ children }) => (
    <Box component='span' sx={{ fontSize: { xs: "11px", sm: "11px" }, color: "#A1AEBF", }}>{children}</Box>
);

const CertificatePortText = ({ children }) => (
    <Box component='span' sx={{ display: "flex" }}>{children}</Box>
);
const SubPortText = ({ children }) => (
    <Box component='span' sx={{ fontSize: { xs: "11px", sm: "11px" }, display: "flex", alignItems: "center", justifyContent: "center", color: "#A1AEBF" }}>{children}</Box>
);

const Title2Text = ({ children }) => (
    <Typography variant='body1' sx={{
        fontSize: { xs: "15px", sm: "16px" }, textAlign: "center", whiteSpace: "nowrap"
    }}>
        <span>{children}</span>
    </Typography>
);


const CustomNextArrow = ({ onClick }) => (
    <IconButton
        style={{ display: 'none', position: 'absolute', top: '0', right: '0', transform: 'translateY(-50%)', zIndex: 10, border: "1px solid #ffa800", borderRadius: '0', color: "#ffa800", background: '#110f0f' }}
        onClick={onClick}
    >
        <ArrowForwardIosIcon />
    </IconButton>
);

const CustomPrevArrow = ({ onClick }) => (
    <IconButton
        sx={{ display: 'none', position: 'absolute', top: '0', right: { xs: '20%', sm: '7%' }, transform: 'translateY(-50%)', zIndex: 10, border: "1px solid #ffa800", borderRadius: '0', color: "#ffa800", background: '#110f0f' }}
        onClick={onClick}
    >
        <ArrowBackIosNewIcon />
    </IconButton>
);

export default Pricing;